import { render, staticRenderFns } from "./_DoCheckbox.vue?vue&type=template&id=5b53d664&scoped=true"
import script from "./_DoCheckbox.vue?vue&type=script&lang=js"
export * from "./_DoCheckbox.vue?vue&type=script&lang=js"
import style0 from "./_DoCheckbox.vue?vue&type=style&index=0&id=5b53d664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b53d664",
  null
  
)

export default component.exports